/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Ares_EmptyInputs */

const cs_property_registry_ares_empty = /** @type {(inputs: Property_Registry_Ares_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro toto IČO se firma nenašla.`)
};

const en_property_registry_ares_empty = /** @type {(inputs: Property_Registry_Ares_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No company found for this IČO.`)
};

/**
* | output |
* | --- |
* | "No company found for this IČO." |
*
* @param {Property_Registry_Ares_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_ares_empty = /** @type {((inputs?: Property_Registry_Ares_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Ares_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_ares_empty(inputs)
	return cs_property_registry_ares_empty(inputs)
});